"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var decode_1 = __importDefault(require("./decode"));
exports.default = (function (virtual) {
    var de = decode_1.default(virtual)[virtual.device.workModeType];
    return function (data) {
        return de ? de(data) : data;
    };
});



// WEBPACK FOOTER //
// ./src/decode/index.ts